import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";

import "./style.css";

import {
  Button,
  FormControlLabel,
  Grid,
  Switch,
  TextField,
} from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { useSelector } from "react-redux";

/* import iconExclamacion from "./iconExclamacion.svg";
import iconExclamacionExcede from "./iconExclamacionExcede.svg";
import iconExclamacionAbono from "./iconExclamacionAbono.svg"; */

import { AutocompleteContacts } from "../form/AutocompleteContacts";
import { useBuy } from "../../../hooks/useBuy";

import {
  getFinalTotals,
  getInfoTipoDoc,
  setNewMontoInItems,
} from "../../../helpers/compras";
import { CircleAlert } from "lucide-react";

export const FormBuy = ({
  initialState,
  setOpen,
  handleOpenExtendedMode,
  loadIniBudget,
}) => {
  // const { listSuppliers } = useSelector(state => state.contacts)
  const { listaTiposDocumentos, detail: defaultParamsBuy } = useSelector(
    (state) => state.general,
  );
  const { initSaveBuy, initUpdateBuy } = useBuy();

  const [form, setForm] = useState(initialState);
  const [msgError, setMsgError] = useState("");

  const checkInitialDataCreate = useCallback(async () => {
    if (form.id === 0) {
      const idTipoDoc =
        initialState?.id_tipo_documento || defaultParamsBuy.id_tipo_documento;

      const { impuesto_nombre, impuesto_porcentaje, impuesto_tipo_calculo } =
        await getInfoTipoDoc(listaTiposDocumentos, idTipoDoc);

      setForm((prev) => ({
        ...prev,
        id_tipo_documento: idTipoDoc,
        impuesto_porcentaje: impuesto_porcentaje,
        impuesto_tipo_calculo: impuesto_tipo_calculo,
        impuesto_nombre: impuesto_nombre,
        id_forma_pago: defaultParamsBuy.id_forma_pago,
        observaciones: defaultParamsBuy.observaciones_compras,
      }));
    }
  }, [
    defaultParamsBuy,
    form.id,
    listaTiposDocumentos,
    initialState?.id_tipo_documento,
  ]);

  const handleChange = ({ target }) => {
    setForm({
      ...form,
      [target.name]: target.value,
    });
  };

  const handleCheckedPay = ({ target }) => {
    setForm({
      ...form,
      [target.name]: target.checked,
    });
  };

  const handleChangeDate = (date) => {
    setForm({
      ...form,
      fecha_compra: date,
    });
  };

  const handleChangeMonto = async (value) => {
    const itemId = form.items[0].id;
    const newItems = await setNewMontoInItems(value.floatValue, itemId, form);
    const { sub_total, monto_base, total_impuesto, total_compra } =
      await getFinalTotals(form, newItems);

    setForm({
      ...form,
      subtotal: sub_total,
      monto_base: monto_base,
      total_impuesto: total_impuesto,
      total_compra: total_compra,
      items: newItems,
    });
  };

  const handleChangeMontoByItems = async (values, id) => {
    const newItems = await setNewMontoInItems(values.floatValue, id, form);
    const { sub_total, monto_base, total_impuesto, total_compra } =
      await getFinalTotals(form, newItems);

    setForm({
      ...form,
      subtotal: sub_total,
      monto_base: monto_base,
      total_impuesto: total_impuesto,
      total_compra: total_compra,
      items: newItems,
    });
  };

  const handleSave = (e) => {
    e.preventDefault();
    setMsgError("");

    if (
      parseInt(form?.id_moneda) === 4 &&
      parseFloat(form?.valor_tipo_cambio) === 0
    ) {
      setMsgError("Falta ingresar tipo de cambio");
      return false;
    }

    if (!form.id_proveedor || form.id_proveedor === "") {
      setMsgError("Falta seleccionar proveedor");
      return false;
    }

    if (parseFloat(form.id) > 0) {
      initUpdateBuy(form, loadIniBudget);
    } else {
      initSaveBuy(form, loadIniBudget);
    }

    setOpen(false);
  };

  const handleChangeProveedor = (proveedor) => {
    setForm({
      ...form,
      id_proveedor: proveedor.id_proveedor,
    });

    if (parseFloat(proveedor.id_proveedor) > 0) {
      setMsgError("");
    }
  };

  useEffect(() => {
    checkInitialDataCreate();

    return () => {
      loadIniBudget();
    };
  }, [checkInitialDataCreate, loadIniBudget]);

  return (
    <>
      <form onSubmit={handleSave}>
        <Grid
          container
          direction="row"
          spacing="20"
          columnSpacing="40"
          alignItems="center"
        >
          <Grid item xs={12}>
            <TextField
              label="Descripción de la compra"
              name="referencia"
              id="outlined-size-small"
              value={form.referencia || ""}
              size="small"
              fullWidth
              placeholder="Ingrese descripción de la compra"
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <AutocompleteContacts
              dataForm={form}
              id_proveedor={form?.id_proveedor}
              handleChangeProveedor={handleChangeProveedor}
            />
            {msgError !== "" && (
              <span className="p-label-error">{msgError}</span>
            )}
          </Grid>

          {form.items?.length > 1 && (
            <Grid item xs={12}>
              <TablaModeItems
                form={form}
                handleChangeMontoByItems={handleChangeMontoByItems}
              />
            </Grid>
          )}

          <Grid item xs={12}>
            {form.monto_base > form.total_por_gastar && (
              <div className="info flex items-start gap-2 text-red-500 text-sm">
                <CircleAlert size={16} />
                <label className="excede">
                  El monto ingresado excede el presupuesto
                </label>
              </div>
            )}
          </Grid>

          <Grid item xs={12}>
            {form?.items?.length === 1 ? (
              <span>
                <NumberFormat
                  className={`monto ${form.monto_base > form.total_por_gastar ? " excede" : form.monto_base < form.total_por_gastar ? "abono" : "normal"}`}
                  customInput={TextField}
                  label="Total base compra"
                  id="outlined-size-small"
                  size="small"
                  fullWidth
                  name="monto_base"
                  value={form.monto_base}
                  thousandSeparator={form.separacion_miles}
                  decimalSeparator={form.separacion_decimales}
                  prefix={`${form.simbolo} `}
                  inputProps={{
                    style: {
                      textAlign: "right",
                    },
                  }}
                  onValueChange={(values) => handleChangeMonto(values)}
                />
              </span>
            ) : (
              <div
                className="d-flex justify-content-between"
                style={{
                  border: "1px solid #EDEDED",
                  padding: "5px",
                  borderRadius: "3px",
                }}
              >
                <label>Total base compra : </label>
                <div className="ms-5">
                  <NumberFormat
                    value={form.monto_base}
                    displayType={"text"}
                    thousandSeparator={form.separacion_miles}
                    decimalSeparator={form.separacion_decimales}
                    prefix={`${form.simbolo} `}
                  />
                </div>
              </div>
            )}
          </Grid>

          <Grid item xs={8}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DesktopDatePicker
                label="Fecha compra"
                inputFormat="dd/MM/yyyy"
                fullWidth
                name="fecha_compra"
                value={form.fecha_compra}
                onChange={handleChangeDate}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
          </Grid>

          <Grid item xs={4}>
            <div className="flex flex-col">
              <label className="text-gray-600">Pagado</label>
              <FormControlLabel
                control={
                  <Switch
                    color="secondary"
                    name="pagado"
                    checked={form.pagado}
                    onChange={handleCheckedPay}
                  />
                }
              />
            </div>
          </Grid>

          <Grid item xs={12} className="text-end">
            <div className="d-flex justify-content-end align-items-center">
              <Link
                to="#"
                className="me-3 p-ver-mas"
                onClick={() => handleOpenExtendedMode(form)}
              >
                Más info
              </Link>
              <Button
                className="p-btn-primary"
                variant="contained"
                size="medium"
                type="submit"
              >
                Guardar
              </Button>
            </div>
          </Grid>
        </Grid>
      </form>
    </>
  );
};

const TablaModeItems = ({ form, handleChangeMontoByItems }) => {
  return (
    <table className="table p-table-global m-2">
      <thead className="p-thead-global">
        <tr className="text-center p-tr-titles-global">
          <th>Servicio</th>
          <th>Monto base</th>
        </tr>
      </thead>
      <tbody>
        {form?.items?.map((it) => (
          <tr className="p-tr-body-global" key={it.id}>
            <td>{it.nombre}</td>
            <td>
              <NumberFormat
                className={`cantidades-item monto ${it.subtotal > it.total_por_gastar ? " excede" : it.subtotal < it.total_por_gastar ? "abono" : "normal"}`}
                value={it.subtotal}
                thousandSeparator={form.separacion_miles}
                decimalSeparator={form.separacion_decimales}
                prefix={`${form.simbolo} `}
                onValueChange={(values) =>
                  handleChangeMontoByItems(values, it.id)
                }
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
